import { UserFull } from '@wellesley/openapi'
import { staticState } from '@wellesley/host-remote/common/staticState'

const getFullUserUrl = (user: UserFull) => {
  const { baseUrl: staticBaseUrl } = staticState.get()
  const baseUrl = staticBaseUrl || window.location.origin
  const username = user.username
  const groupName = user.groupName
  const groupUsername = user.groupUserName

  if (groupUsername !== username && groupName) {
    return `${baseUrl}/g/${groupName}/@${groupUsername}`
  }

  return user.local
    ? `${baseUrl}/@${username}`
    : `https://${user.domain}/@${username}`
}
export default getFullUserUrl
